import { render, staticRenderFns } from "./yc-no-content.vue?vue&type=template&id=5065d5d2&scoped=true"
import script from "./yc-no-content.vue?vue&type=script&lang=js"
export * from "./yc-no-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5065d5d2",
  null
  
)

export default component.exports